module.exports = __webpack_public_path__ + "img/icon-sign-success.6fa008db.png";